module.exports = __webpack_public_path__ + "static/media/lock-tool.ffa6d1c0.svg";